import Icon from "@/components/Global/Icon/Icon";

export const HealthPlansHeader = () => {
  return (
    <div className="row mx-0 align-items-center py-4">
      <div className="col-auto">
        <Icon icon="plans-icon" />
      </div>
      <div className="col">
        <h2 className="mb-0">Health plans</h2>
      </div>
    </div>
  );
};
